import { getApp, getApps, initializeApp, type FirebaseApp } from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";
import { getFirestore, type Firestore } from "firebase/firestore";

// Customer-facing Firebase project config. These are public values (safe in
// the browser bundle) and are inlined at build time from NEXT_PUBLIC_* env
// vars — the same mechanism as NEXT_PUBLIC_SNIPCART_API_KEY.
const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

/** True when the build was given the Firebase config. */
export function isFirebaseConfigured(): boolean {
  return Boolean(
    firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId,
  );
}

let cachedApp: FirebaseApp | null = null;

function getFirebaseApp(): FirebaseApp {
  if (!isFirebaseConfigured()) {
    throw new Error(
      "Firebase is not configured — the NEXT_PUBLIC_FIREBASE_* env vars are missing.",
    );
  }
  if (cachedApp) {
    return cachedApp;
  }
  cachedApp = getApps().length
    ? getApp()
    : initializeApp(firebaseConfig as Record<string, string>);
  return cachedApp;
}

/** The Firebase Auth instance for the customer membership system. */
export function getFirebaseAuth(): Auth {
  return getAuth(getFirebaseApp());
}

/** The Cloud Firestore instance holding customer profiles + order history. */
export function getFirebaseDb(): Firestore {
  return getFirestore(getFirebaseApp());
}
